import React, { useEffect, useState } from "react";
import { FC } from "react";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import Link, { LinkProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import ADIColors from "@NA/Utils/ADIColors";
import translate from "@insite/client-framework/Translate";
import { bannerButtonGaTagV2 } from "@NA/Utils/GtmUtility";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";

const enum fields {
    title = "title",
    description = "description",
    shopNow = "shopNow",
    shopNowUrl = "shopNowUrl",
    desktopBg = "desktopBg",
    tabletBg = "tabletBg",
    mobileBg = "mobileBg",
    gaPromoTag = "gaPromoTag",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.description]: string;
        [fields.shopNow]: string;
        [fields.shopNowUrl]: string;
        [fields.desktopBg]: string;
        [fields.tabletBg]: string;
        [fields.mobileBg]: string;
        [fields.gaPromoTag]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        session: state.context.session,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface miniBannerStyles {
    bannerWrapper?: any;
    mainGridContainer?: GridContainerProps;
    imgGridItem?: GridItemProps;
    img?: ImgProps;
    textGridContainer?: GridContainerProps;
    textGridItem?: GridItemProps;
    mainHeading?: TypographyProps;
    subHeading?: TypographyProps;
    linkGridItem?: GridItemProps;
    shopNow?: TypographyProps;
    bannerUrl?: TypographyProps;
}

const miniBannerStyles: miniBannerStyles = {
    bannerWrapper: {
        css: css`
            margin: 0px auto;
            padding: 0 0px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null,
                    css`padding: 0 10px;`,
                ], "max",);
            }}
        `,
    },
    mainGridContainer: {
        css: css`
            height: 100%;
            border-radius: 5px;
            margin: 0 0 0 auto;
            ${props => breakpointMediaQueries(props.theme, [
            css`border-radius: 4px;`,
            css`border-radius: 4px;`,
            css`border-radius: 5px; height: 110px;`,
        ])}
            ${GridOffset} { 
                justify-content: flex-end;
                min-height: 160px;
                ${props => breakpointMediaQueries(props.theme, [
            css`min-height: 270px;`,
            css`min-height: 270px;`,
            css`min-height: 110px;`,
        ])}
            }
        `,
    },
    imgGridItem: {
        css: css`
            padding: 0 0 0 11px;
            border-radius: 5px;
            ${props => breakpointMediaQueries(props.theme, [
            css`border-radius: 4px`,
            css`border-radius: 4px`,
            css`border-radius: 5px`,
        ])}
        `,
    },
    img: {
        css: css`
            border-radius: 5px;
            width: 100%;
            ${props => breakpointMediaQueries(props.theme, [
            css`border-radius: 0;border-radius: 4px`,
            css`border-radius: 0;border-radius: 4px`,
            css`width: 40%; height: 100%; border-radius: 5px;`,
        ])}
        `,
    },
    bannerUrl: {
        css: css`
            width: 100%;
            justify-content: flex-end;
            display: inline-block;
        `,
    },
    textGridContainer: {
        css: css`
            height: 100%;
        `,
    },
    textGridItem: {
        css: css`
            padding: 0px 10px 0 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 160px;
            ${props => breakpointMediaQueries(props.theme, [
            css`padding: 0 20px 19px 20px !important;height: 270px;justify-content: end;text-align: center;align-items: center;`,
            css`padding: 0 20px 19px 20px !important;height: 270px;justify-content: end;text-align: center;align-items: center;`,
            css`padding: 0 0 50px 30px;height: 110px;`,
        ])}
        `,
    },
    mainHeading: {
        css: css`
            font-family: 'Nunito Sans';
            font-size: 34px;
            font-weight: bold;
            color: ${ADIColors.darkBlue1};
            margin: 5px 0 5px;
            line-height: normal;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [
                    css`font-size: 24px;color: ${ADIColors.white};margin: 0 auto;`,
                    css`font-size: 24px;color: ${ADIColors.white};margin: 0 auto;`,
                    css`font-size: 23px;color: ${ADIColors.white};margin: 0;`,
                ],);
            }}
        `,
    },
    subHeading: {
        css: css`
            font-family: 'Nunito Sans';
            font-size: 20px;
            color: ${ADIColors.darkBlue1};
            line-height: normal;
            margin: 0;
            max-width: 508px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [
                    css`font-size: 16px;color: ${ADIColors.white};max-width: 100%;`,
                    css`font-size: 16px;color: ${ADIColors.white};max-width: 100%;`,
                    css`font-size: 14px;color: ${ADIColors.white};max-width: 285px`,
                ],);
            }}
        `,
    },
    linkGridItem: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 160px;
            align-items: flex-end;
            padding-right: 65px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null,
                    css`display: flex;`,
                    css`align-items: center;height: auto;`,
                    css`padding-right: 45px;`,], "max",);
            }}
        `,
    },
    shopNow: {
        css: css`
            margin: 0 0 0 0;
            display: block;
            width: 170px;
            font-size: 16px;
            font-weight: bold;
            color: ${ADIColors.blue1};
            padding: 9px 12.5px;
            border-radius: 5px;
            border: solid 1px ${ADIColors.blue1};
            text-align: center;
            background: ${ADIColors.white};
            line-height: normal;
            &:hover {
                color: ${ADIColors.blue1};
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, css`                
                margin: 0; `,],);
            }}
            ${TypographyStyle} {
                color: ${ADIColors.white};
            }
        `,
    },
};

const SmartMiniBanner: FC<Props> = ({ fields, session }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;

    useEffect(() => {
        const onWindowResize = () => {
            if (window.innerWidth <= 767) {
                setIsMobile(true);
                setIsTablet(false);
            } else if (window.innerWidth <= 1181) {
                setIsTablet(true);
                setIsMobile(false);
            } else {
                setIsTablet(false);
                setIsMobile(false);
            }
        };

        onWindowResize();
        window.addEventListener('resize', onWindowResize);
        return () => {
            window.removeEventListener('resize', onWindowResize);
        };
    }, []);

    const backgroundStyle = fields.desktopBg ? {
        backgroundImage: isMobile
            ? `url(${fields.mobileBg})`
            : isTablet
                ? `url(${fields.tabletBg})`
                : `url(${fields.desktopBg})`,
        backgroundSize: "100% 100%",
        maxWidth: "100%",
    } : {};

    return (
        <>
            {!isAuthenticated &&
                <StyledWrapper {...miniBannerStyles.bannerWrapper}>
                    <GridContainer {...miniBannerStyles.mainGridContainer} style={backgroundStyle}>
                        <Link href={fields.shopNowUrl} {...miniBannerStyles.bannerUrl} data-ga-promo={fields.gaPromoTag}>
                            <GridItem width={[12, 12, 12, 12, 12]}>
                                <GridContainer {...miniBannerStyles.textGridContainer}>
                                    <GridItem width={[12, 12, 5, 4, 4]} {...miniBannerStyles.textGridItem}>
                                        <Typography variant="h3" {...miniBannerStyles.mainHeading}>
                                            {fields.title}
                                        </Typography>
                                        <Typography variant="p" {...miniBannerStyles.subHeading}>
                                            {fields.description}
                                        </Typography>
                                    </GridItem>
                                    <GridItem width={[12, 12, 3, 3, 3]} {...miniBannerStyles.linkGridItem}>
                                        <Typography variant="p"  {...miniBannerStyles.shopNow}>
                                            {fields.shopNow}
                                        </Typography>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </Link>
                    </GridContainer>
                </StyledWrapper>
            }
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(SmartMiniBanner),
    definition: {
        group: "Common",
        displayName: "ADI Smart mini Banner",
        fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.description,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.shopNow,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.shopNowUrl,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.desktopBg,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.tabletBg,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.mobileBg,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.gaPromoTag,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
